var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import Badge from '../Badge/Badge';
import SkeletonBox from './SkeletonBox';
import useRandomSkeletonWidth from './useRandomSkeletonWidth';
/**
 * @param {object} props
 * @param {number} [props.offset] The offset for a staggered animation.
 * @param {string | number} [props.width]
 * @param {string} [props.variant] The label variant, defined in labelVariants.js.
 * @param {string} [props.className]
 */
export default function SkeletonBadge(_a) {
    var { width, offset = 0, variant = 'default' } = _a, rest = __rest(_a, ["width", "offset", "variant"]);
    const [getWidth] = useRandomSkeletonWidth(1, { width });
    return (jsx(SkeletonBox, Object.assign({ as: Badge, offset: offset, width: getWidth(0), sx: {
            variant: `text.${variant}`,
            transform: 'scaleY(0.7)',
        } }, rest)));
}
//# sourceMappingURL=SkeletonBadge.js.map